function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.7 1.8L1.3 18.2",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.3 19.5c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8L21.9.7c.6-.4 1.4-.3 1.8.2.4.6.3 1.4-.2 1.8L2.1 19.3c-.3.1-.5.2-.8.2z",
  fill: "#231F20"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20"
  }, props), _ref);
};

export default SvgComponent;